// extracted by mini-css-extract-plugin
export default {"header":"header_header__YoEqp","wrapper":"header_wrapper__zdkMt"};